export const MODAL_CLOSE_ALL = "MODAL_CLOSE_ALL";
export const MODAL_OPEN_ANY = "MODAL_OPEN_ANY";
export const PASSWORD_EYE_TOGGLE = "PASSWORD_EYE_TOGGLE";
export const FORGOT_PASSWORD_MAIL_REQUEST = "FORGOT_PASSWORD_MAIL_REQUEST";
export const FORGOT_PASSWORD_MAIL_SUCCESS = "FORGOT_PASSWORD_MAIL_SUCCESS";
export const JOIN_CHALLENGE_PASSWORD_MODAL_OPEN = "JOIN_CHALLENGE_PASSWORD_MODAL_OPEN";
export const JOIN_CHALLENGE_PASSWORD_MODAL_CLOSE = "JOIN_CHALLENGE_PASSWORD_MODAL_CLOSE";